import { get } from 'lodash'
import routes from '~/const/routes'

export const state = () => ({
  items: [],
  meta: {
    totalItems: null
  },
  requestParams: null
})

export const getters = {
  items: state => state.items,
  meta: state => state.meta,
  requestParams: state => state.requestParams
}

export const mutations = {
  RESET(state) {
    state.items = []
    state.meta = { totalItems: null }
    state.requestParams = null
  }
}

export const actions = {
  async getAll({ commit }, { config = {} }) {
    const { data, meta } = get(await this.$axios.get(routes.peopleforce.list(), config), 'data')

    commit(
      'AFTER_GET_ALL',
      {
        namespace: 'peopleforce',
        items: data,
        meta,
        params: config.params
      },
      { root: true }
    )

    return { data, meta }
  },
  async create({ commit }, { payload = {}, config = {} }) {
    const data = get(await this.$axios.post(routes.peopleforce.list(), payload, config), 'data')
    commit(
      'AFTER_CREATE',
      {
        namespace: 'peopleforce',
        item: data
      },
      { root: true }
    )
    return data
  },
  async update({ commit }, { id, payload = {}, config = {} }) {
    const data = get(
      await this.$axios.put(routes.peopleforce.concrete(id), payload, config),
      'data'
    )
    commit(
      'AFTER_UPDATE',
      {
        namespace: 'peopleforce',
        item: data
      },
      { root: true }
    )
    return data
  },
  async connection({ commit }, payload) {
    const { data } = await this.$axios.post(routes.peopleforce.connection(), payload)

    return data
  }
}
